class KupAbonamentLink {
  constructor() {
    this.abonamentSelect = $(".abonaments select");
    this.buyASubscriptionBtnUrl = $(".js-buy-a-subscription").attr("href");
  }

  events() {
    const _this = this;

    this.abonamentSelect.on("change", function() {
      _this.setSubscriptionButtonUrl($(this));
    });
  }

  setSubscriptionButtonUrl(select) {
    let selectedOptionValue = select.val();
    let button = select
      .parents(".spektakl__item")
      .find(".js-buy-a-subscription");
    button.attr("href", this.buyASubscriptionBtnUrl + selectedOptionValue);
  }

  setSubscriptionButtonsUrl() {
    const _this = this;

    $.each(this.abonamentSelect, function() {
      _this.setSubscriptionButtonUrl($(this));
    });
  }

  init() {
    this.events();
    this.setSubscriptionButtonsUrl();
  }
}

export default KupAbonamentLink;
